'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _followRedirects = require('follow-redirects');

var _zlib = require('zlib');

var _zlib2 = _interopRequireDefault(_zlib);

var _es6Promise = require('es6-promise');

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _response = require('../response');

var _response2 = _interopRequireDefault(_response);

var _headers = require('../headers');

var _headers2 = _interopRequireDefault(_headers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 @module http/node
 */

var contentEncodings = ['gzip', 'compress', 'deflate'];

var getHeaders = function getHeaders(request) {

  return (0, _lodash2.default)(request.headers.map).mapValues(function (values) {
    return _lodash2.default.join(values, ', ');
  }).mapKeys(function (value, key) {
    return key.toLowerCase();
  }).thru(function (headers) {
    return _lodash2.default.isUndefined(request._bodyFormData) ? headers : _lodash2.default.assign({}, headers, request._bodyFormData.getHeaders());
  }).value();
};

var getBody = function getBody(headers, data) {

  var buffer = Buffer.concat(data);

  if (_lodash2.default.has(headers.map, 'content-encoding') && _lodash2.default.intersection(contentEncodings, headers.map['content-encoding']).length > 0) return _zlib2.default.unzipSync(buffer).toString();

  return buffer.toString();
};

var httpNode = function httpNode(request) {
  var _parseUrl = (0, _urlParse2.default)(request.url);

  var protocol = _parseUrl.protocol;
  var hostname = _parseUrl.hostname;
  var port = _parseUrl.port;
  var auth = _parseUrl.auth;
  var pathname = _parseUrl.pathname;
  var query = _parseUrl.query;
  var hash = _parseUrl.hash;

  var client = protocol === 'https:' ? _followRedirects.https : _followRedirects.http;
  var path = pathname + query + hash;
  var options = {
    method: request.method,
    protocol: protocol,
    hostname: hostname,
    port: port,
    auth: auth,
    pathname: path,
    path: path,
    headers: getHeaders(request)
  };

  return new _es6Promise.Promise(function (resolve, reject) {

    var data = [];
    var timer = void 0;
    var req = client.request(options, function (res) {

      res.on('data', function (chunk) {
        return data.push(new Buffer(chunk));
      });

      res.on('end', function () {

        var headers = new _headers2.default(res.headers);
        var body = getBody(headers, data);

        if (request.timeout) clearTimeout(timer);

        return resolve(new _response2.default(body, {
          urlList: _lodash2.default.reverse(res.fetchedUrls),
          status: res.statusCode,
          statusText: res.statusMessage,
          headers: headers
        }));
      });
    });

    if (!_lodash2.default.isUndefined(request._bodyFormData)) request._bodyFormData.pipe(req);

    req.on('error', function (error) {
      return reject(error);
    });

    req.end(request._bodyText);

    if (request.timeout) {

      timer = setTimeout(function () {

        req.abort();

        return reject(new Error('Fetch timeout exceeded'));
      }, request.timeout);
    }
  });
};

exports.default = httpNode;